const normalizeProp = <T>(prop: string | string[]): string[] =>
  Array.isArray(prop) ? prop : prop.split('.')

/* eslint-disable @typescript-eslint/no-explicit-any */
export const evalValue = <T, R = any>(item: T, prop: string | string[]) =>
  normalizeProp(prop).reduce((prev, prop) => prev[prop], item as any) as R
/* eslint-enable @typescript-eslint/no-explicit-any */

export default evalValue
